module.exports = __webpack_public_path__ + "img/not_message.d425268b.png";